import { OnboardingTooltip } from '@cian/ui-kit';
import * as React from 'react';

import { CompareFlightOnboardingContent } from './CompareFlightOnboardingContent';
import * as styles from '../NewbuildingCompareButton.css';

export interface ICompareFlightButtonOnboardingProps extends React.PropsWithChildren {
  open: boolean;
  onClose(): void;
  onAboutComparisonClick(): void;
}

export function CompareFlightButtonOnboarding({
  children,
  open,
  onClose,
  onAboutComparisonClick,
}: ICompareFlightButtonOnboardingProps) {
  return (
    <OnboardingTooltip
      theme="blue"
      content={<CompareFlightOnboardingContent onAboutComparisonClick={onAboutComparisonClick} />}
      placement="left-start"
      portal={false}
      open={open}
      onClose={onClose}
      flip={false}
    >
      <div className={styles['onboarding-anchor']}>{children}</div>
    </OnboardingTooltip>
  );
}
